import React, { useRef } from 'react';

import { Details, useDetails } from '@primer/react';

import isNumber from 'lodash/isNumber';

import { isJSON } from '../../../utils/text_utils';

import Label from '../../common/Labels/Label';
import RadioGroup from '../../common/RadioGroup/RadioGroup';
import TextInputWithError from '../../common/TextInputs/TextInputWithError/TextInputWithError';

import CronGenerator from '../../CronGenerator/CronGenerator'

const AdvancedSettingsMenu = ({
  jsonStr,
  timeoutVal,
  setJSONStr,
  setTimeoutVal,
  disabled = false,
  isIndefiniteTask = false,
}) => {
  const jsonPlaceholder = '{ "arg": "value" }';
  return (
    <div className="flex flex-col items-start justify-start p-1 mx-2">
      <div className="flex items-start justify-between w-full">
        <div className="flex flex-col basis-8/12 mx-1">
          <Label bold>Json arguments</Label>
          <TextInputWithError
            type="text"
            errorMessage="Invalid JSON"
            placeholder={jsonPlaceholder}
            value={jsonStr}
            onChange={setJSONStr}
            onEntryValidation={entry => isJSON(entry)}
            disabled={disabled}
            block
          />
        </div>
        {
          !isIndefiniteTask && (
            <div className="flex flex-col basis-4/12 mx-1">
              <Label bold>Timeout (sec)</Label>
              <TextInputWithError
                type="number"
                errorMessage="Invalid Number"
                placeholder="Enter timeout in seconds"
                value={timeoutVal}
                onChange={setTimeoutVal}
                onEntryValidation={entry => !entry?.length || (isNumber(parseFloat(entry)) && parseFloat(entry) >= 0)}
                disabled={disabled}
                step={1}
                block
              />
            </div>
          )
        }
      </div>
    </div>
  )
}

export const TaskCreationPanel = ({
  taskName, setName, setSchedule, taskType, setTaskType, jsonStr, setJSONStr, timeoutVal, setTimeoutVal,
}) => {
  const ref = useRef(null);

  const items = [
    {
      id: 'run_immediately',
    },
    {
      id: 'run_recurring',
    },
    {
      id: 'run_continuously',
    }
  ]

  const renderItem = ({
    id,
  }) => {
    if (id === 'run_immediately') {
      return (
        <div className="flex flex-col">
          <Label className="mb-2" size="sm">
            Run immediately
          </Label>
        </div>
      )
    }
    if (id === 'run_recurring') {
      return (
        <div className="flex flex-col">
          <Label className="mb-2" size="sm">
            Run recurringly
          </Label>
          <CronGenerator
            onValueUpdate={setSchedule}
            disabled={taskType !== 'run_recurring'}
          />
        </div>
      )
    }
    if (id === 'run_continuously') {
      return (
        <div className="flex flex-col">
          <Label className="mb-2" size="sm">
            Run indefinitely
          </Label>
        </div>
      )
    }
  }

  const {
    getDetailsProps, open, onToggle
  } = useDetails({ closeOnOutsideClick: false, ref })

  const isIndefinite = taskType === 'run_continuously';

  return (
    <div className="flex flex-col">
      <div className="flex flex-col m-1">
        <Label bold>Task Name</Label>
        <TextInputWithError
          type="text"
          className="ml-2 w-full"
          errorMessage="Please enter a name for your task."
          placeholder="Add Task Name"
          value={taskName}
          onChange={setName}
          onEntryValidation={entry => entry?.length > 0}
          block
        />
      </div>
      <div className="flex flex-col m-1">
        <Label bold>Task Type</Label>
        <RadioGroup
          id="task-type-selection"
          selectedItemId={taskType}
          items={items}
          onSelect={setTaskType}
          renderItem={renderItem}
        />
      </div>
      <Details
        {...getDetailsProps()}
        onToggle={(...x) => {
          if (x === ref) {
            onToggle();
          }
        }}
      >
        <summary className="flex cursor-pointer" style={{ padding: '10px 0px' }}><b>Advanced Settings {open ? <>&#9650;</> : <>&#9660;</>}</b></summary>
        <AdvancedSettingsMenu
          jsonStr={jsonStr}
          timeoutVal={isIndefinite ? '' : timeoutVal}
          setJSONStr={setJSONStr}
          setTimeoutVal={setTimeoutVal}
          isIndefiniteTask={isIndefinite}
        />
      </Details>
    </div>
  )
}

export default TaskCreationPanel;
